import { View } from 'react-native';
import { Text } from '@ui-kitten/components';
import PropTypes from 'prop-types';

import ThemeStyle from '../../Theme/styles';

import Button from '../Button';

function StoreCart({ storeName, onStoreNamePress, contentRight, ...rest }) {
  return (
    <View
      style={[
        ThemeStyle.pageHorizontalSpacing,
        ThemeStyle.spacingTopMedium,
        ThemeStyle.spacingBottomMedium,
        ThemeStyle.flexDirectionRowCenterSpaceBetween,
      ]}
      {...rest}
    >
      <Button onPress={onStoreNamePress} style={ThemeStyle.flex1} plain>
        <Text style={ThemeStyle.flex1}>{storeName}</Text>
      </Button>

      {!!contentRight && (
        <View style={ThemeStyle.spacingLeft}>{contentRight}</View>
      )}
    </View>
  );
}

StoreCart.propTypes = {
  sectionIndex: PropTypes.number,
  storeName: PropTypes.string.isRequired,
  onStoreNamePress: PropTypes.func.isRequired,
  contentRight: PropTypes.node,
};

export default StoreCart;
